<script>
///ESTO YA NO USO, ESTÁ EN SIDEBARNAV
// this.$store.state.usuario.tipo=='2'
import {store} from '../../store';
let sidebarMenu;
const Menu1 = [
   { path: '/bienvenido', icon: 'fa fa-th', title: 'Bienvenido' },
  //  { path: '/emisores', icon: 'fa fa-industry', title: 'Emisores' },
  { path: '/personal', icon: 'fa fa-users', title: 'Personal' },
  { path: '/links', icon: 'fa fa-link', title: 'Links' },
  { path: '/comisiones', icon: 'fa fa-list', title: 'Comisiones', label: '',
    children: [
      { path: '/comisiones/chip', title: 'Chips'},
      { path: '/comisiones/equipo', title: 'Equipos' },
    ]
  },
  { path: '/entregas', icon: 'fa fa-list', title: 'Entregas', label: '',
    children: [
      { path: '/entregas/chip', title: 'Chips'},
      { path: '/entregas/equipo', title: 'Equipos' },
    ]
  },
  { path: '/reporte', icon: 'fa fa-list', title: 'Reportes', label: '',
    children: [
      { path: '/reporte/pago-personal', title: 'Pago Personal'},
    ]
  },
]
const Menu2 = [
   { path: '/inicio', icon: 'fa fa-th', title: 'Bienvenido' },
  //  { path: '/emisores', icon: 'fa fa-industry', title: 'Emisores' },
  
]

if(store.state.usuario.tipo==2){
  sidebarMenu=[...Menu1]
}else{
  sidebarMenu=[...Menu2]
}
  export default sidebarMenu;
 


</script>
